import { InputText } from 'component-library/index';
import React from 'react';
import { memo } from 'react';
import { useField } from '../../../providers/ModernAcquisitionProvider/useField';
import { regexValidation } from '../../../utils/cob-utils';
import { generateFieldErrorMessage } from '../../../utils/error-message';

export interface ISuffixFieldWithProviderProps {
    fieldKey: 'suffix';
    name: string;
    label?: string;
    id?: string;
    disabled?: boolean;
    onBlurCallback?: () => void;
    onFocusCallback?: () => void;
}

const MemoizedInputText = memo(InputText);

export const SuffixFieldWithProvider = memo(function SuffixFieldWithProvider(props: ISuffixFieldWithProviderProps & React.HTMLAttributes<HTMLInputElement>, ...rest) {

    const { field, updateField } = useField(props.fieldKey);

    const getValidSubstring = (suffix: string): string => {
        const validationResult = regexValidation().allow.name_suffix.exec(suffix);
        return validationResult[0];
    };

    const isSuffixValid = (suffix: string): boolean => {
        if (!suffix) {
            return true;
        }

        const validationResult = getValidSubstring(suffix);
        return !!validationResult;
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {

        if (field.value !== event.target.value) {
            updateField({ ...field, state: 'neutral', value: event.target.value });
        } else {
            updateField({ ...field, value: field.value });
        }
    }

    const handleBlur = (): void => {

        const isValid = isSuffixValid(field.value as string);

        if (isValid) {
            updateField({ ...field, state: 'success', errorType: 'None' })
        } else {
            updateField({ ...field, state: 'error', errorType: 'RequiredField' })
        }

        //Incase someone wants to extend blur functionality.
        props.onBlurCallback && props.onBlurCallback();

    }

    const handleFocus = (): void => {
        if (field.state === 'success') {
            updateField({ ...field, state: 'neutral' })
        }

        //Incase someone wants to extend focus functionality.
        props.onFocusCallback && props.onFocusCallback();
    }

    return (
        <MemoizedInputText
            name={props.name}
            label={props.label}
            id={props.id}
            value={field.value}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            errorMessage={generateFieldErrorMessage(props.name)}
            state={field.state}
            maxLength={4}
            disabled={props.disabled}
            {...rest}
        />

    )

});

export default SuffixFieldWithProvider;